import { FC, useEffect } from 'react'

import styled from 'styled-components'
import { useIntercom } from 'react-use-intercom'

import SearchIcon from 'src/Assets/Svg/search-icon.svg?react'
import { PrimaryInput } from 'src/Components/PrimaryInput'

import { TiktokWidgetList } from './TiktokWidgetList'
import { useTiktokWidgetSearch } from './useTiktokWidgetSearch'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const TiktokWidgetSearch: FC = () => {
  const { onTrackSearchHandler, tracks, error, loading } =
    useTiktokWidgetSearch()
  const { hardShutdown } = useIntercom()

  useEffect(() => {
    hardShutdown()
  }, [hardShutdown])
  return (
    <Wrapper>
      <PrimaryInput
        placeholder='Type your track name or URL from TikTok'
        prefix={<SearchIcon width={'16px'} height={'16px'} />}
        onChange={(event) =>
          onTrackSearchHandler({ searchInput: event.target.value })
        }
      />
      <TiktokWidgetList tracks={tracks} error={error} loading={loading} />
    </Wrapper>
  )
}

export default TiktokWidgetSearch
